<template>
  <div>
    <router-link aria-label="Página anterior" v-if="screenTrack[0] >= 2" class="rout-bot bot-left hvr-grow" @click.native="guardarubicacion()" :to="linksPath+ (screenTrack[0]-1)"></router-link>
  </div>
</template>

<script>
import ScormMix from '../../js/mixins/scormmixins'
export default {
  props: {
    linksPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    nextPant() {
      return this.$store.state.nextPant;
    },
    screenTrack() {
      return this.$store.state.screens;
    }
  },
  mixins: [ScormMix]
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// NavAtras.vue?6433674b